import createClient from "openapi-fetch"

import type { paths } from "./generated/insights-api-schema"

// Must be a function instead of a static variable for msw v2 compatibility
// because it needs to be set up after msw overwrites fetch
// See https://github.com/openapi-ts/openapi-typescript/issues/1878
export const client = () =>
  createClient<paths>({
    baseUrl: process.env.REACT_APP_API_BASE_URL ?? "",
    bodySerializer: (body) =>
      JSON.stringify(body, (_key: string, value: unknown): unknown =>
        value === undefined ? null : value
      ),
  })
